var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.5V11.9C20 11.0599 20 10.6399 19.8365 10.319C19.6927 10.0368 19.4632 9.8073 19.181 9.66349C18.8601 9.5 18.4401 9.5 17.6 9.5H16.4C15.5599 9.5 15.1399 9.5 14.819 9.66349C14.5368 9.8073 14.3073 10.0368 14.1635 10.319C14 10.6399 14 11.0599 14 11.9V12.5M10.25 12.5H23.75M22.25 12.5V20.9C22.25 22.1601 22.25 22.7902 22.0048 23.2715C21.789 23.6948 21.4448 24.039 21.0215 24.2548C20.5402 24.5 19.9101 24.5 18.65 24.5H15.35C14.0899 24.5 13.4598 24.5 12.9785 24.2548C12.5552 24.039 12.211 23.6948 11.9952 23.2715C11.75 22.7902 11.75 22.1601 11.75 20.9V12.5",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSvg);
export default __webpack_public_path__ + "static/media/upload_svg.bd1a64d9f536cd3259ac957c1564b845.svg";
export { ForwardRef as ReactComponent };